module.exports = __webpack_public_path__ + "img/jy.b41ed51d.png";